var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.responsive == 'PC')?_c('div',{staticStyle:{"width":"470px","height":"475px"},attrs:{"id":_vm.id}}):_vm._e(),(_vm.responsive == 'mobile' || _vm.responsive == 'pad')?_c('div',{attrs:{"id":_vm.id}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }